export default {
  reset: (state) => {
    state.item = {
      title: null,
      description: null,
      covers: null,
      numberOfQuestions: null,
      passRate: null,
      questions: [],
      template: null,
    };
    state.isLoading = false;
  },
  setItem: (state, item) => {
    state.item = item;
  },
  setIsLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  addQuestion: (state) => {
    state.item.questions.push({
      title: null,
      description: null,
      numberOfAnswers: null,
      answers: [],
    })
  },
  removeQuestion: (state, index) => {
    if (!state.item.questions || !state.item.questions[index]) {
      return;
    }
    state.item.questions.splice(index, 1);
  },
  updateQuestion: (state, payload) => {
    if (!state.item.questions || !state.item.questions[payload.index]) {
      return;
    }
    const questions = state.item.questions;
    questions.splice(payload.index, 1, payload.data);

    state.item = { ...state.item, questions };
  },
  addAnswer: (state, questionIndex) => {
    if (!state.item.questions || !state.item.questions[questionIndex]) {
      return;
    }

    state.item.questions[questionIndex].answers.push({
      text: null,
      correct: false,
    });
  },
  updateAnswer: (state, data) => {
    if (!state.item.questions || !state.item.questions[data.questionIndex]) {
      return;
    }
    const question = state.item.questions[data.questionIndex];
    if (!question.answers || !question.answers[data.index]) {
      return;
    }

    question.answers.map((answer, index) => {
      if (index === data.index) {
        return;
      }
      answer.correct = false;
    });

    question.answers[data.index] = data.item;
  },
  removeAnswer: (state, data) => {
    if (!state.item.questions || !state.item.questions[data.questionIndex]) {
      return;
    }
    const question = state.item.questions[data.questionIndex];
    if (!question.answers || !question.answers[data.index]) {
      return;
    }

    question.answers.splice(data.index, 1);
  },
};
